import React, { Component } from 'react'
import TextInput from 'components/UI/TextInput'
import Button from 'components/UI/Button'
import Switch from 'components/UI/Switch'
import Dropdown from 'components/UI/Dropdown'
import {
  handleErrorMessageAlert,
  handleCloseAllAlerts
} from 'components/UI/Alert'
import {
    FormContainer,
    FormContent,
    FormFooter,
    FormWrapper
} from '../CPT4Form/styles';
import PrivacyPolicyCheckBox from '../../content/PrivacyPolicy/PrivacyPolicyCheckBox'

interface IFormProps {
  onSubmit: (form: CPT4) => void
  onClose: () => void;
  cpt4Codes: any;
  serviceAreas: any;
  cpt4ToEdit?: {
    id: number;
    cpt4Id: number;
    contractGroup: string;
    serviceAreaId: number;
    manual?: boolean;
  };
}

interface IErrorFields {
    cpt4Id?: string;
    contractGroup?: string;
    serviceAreaId?: string;
}

interface CPT4 {
    cpt4Id: number;
    contractGroup: string;
    serviceAreaId: number;
    manual?: boolean;
}
  
  interface IFormState {
    form: CPT4
    errors: IErrorFields
  }

class MostActiveCPT4Form extends Component<IFormProps, IFormState> {
  constructor(props: IFormProps) {
    super(props)
    const { cpt4ToEdit } = props;
    this.state = {
      form: {
        cpt4Id: cpt4ToEdit ? cpt4ToEdit.cpt4Id : 0,
        contractGroup: cpt4ToEdit ? cpt4ToEdit.contractGroup : '',
        serviceAreaId: cpt4ToEdit ? cpt4ToEdit.serviceAreaId : 0,
        manual: cpt4ToEdit ? !!cpt4ToEdit.manual : false,
      },
      errors: {}
    }
  }

  render() {
    const { form, errors } = this.state
    const { onClose, cpt4ToEdit, cpt4Codes, serviceAreas } = this.props

    return (
      <FormWrapper>
        <FormContainer>
          <FormContent>
            <Dropdown
                name={'cpt4Id'}
                value={form.cpt4Id}
                options={cpt4Codes}
                onSelect={this.onUpdate}
                label={'CPT4'}
                placeholder={'Select CPT4'}
                tooltipText={''}
            />
            <TextInput
              name={'contractGroup'}
              label={'Contract Group'}
              placeholder={'Enter Contract Group'}
              errorLabel={errors.contractGroup || ''}
              handleChange={this.onUpdate}
              value={form.contractGroup}
            />
            <Dropdown
                name={'serviceAreaId'}
                value={form.serviceAreaId}
                options={serviceAreas}
                onSelect={this.onUpdate}
                label={'Service Area'}
                placeholder={'Select Service Area'}
                tooltipText={''}
            />
            <Switch
              label={'Manual'}
              checked={form.manual}
              handleChange={() => this.onUpdate('manual', !form.manual)}
            />
          </FormContent>
        </FormContainer>
        <FormFooter>
            <Button variant={'default'} onClick={this.onSubmit}>
              {cpt4ToEdit ? 'Save' : 'Add'}
            </Button>
            <Button variant={'text'} onClick={onClose}>
              Cancel
            </Button>
        </FormFooter>
      </FormWrapper>
    )
  }
  private isValid = (): boolean => {
    const { form } = this.state
    const errors: IErrorFields = {}

    if (!form.cpt4Id) {
      errors.cpt4Id = 'You must select a CPT4'
    }

    if (!form.contractGroup) {
        errors.contractGroup = 'You must enter the Contract Group'
      }

    if (!form.serviceAreaId) {
      errors.serviceAreaId = 'You must select a Service Area'
    }

    this.showAlertErrors(errors)

    this.setState({ errors })
    return !Object.keys(errors).length
  }

  private showAlertErrors = (errors: IErrorFields) => {
    Object.keys(errors).forEach(prop => {
      // @ts-ignore
      if (errors[prop]) {
        // @ts-ignore
        handleErrorMessageAlert(errors[prop])
      }
    })
  }

  private onUpdate = (name: string, value: any) => {
    this.setState((prevState: IFormState) => ({
      ...prevState,
      form: {
        ...prevState.form,
        [name]: value
      },
      errors: {
        ...prevState.errors,
        [name]: ''
      }
    }))
  }
  private onSubmit = async () => {
    const {
      form
    } = this.state
    // const { onClose } = this.props
    handleCloseAllAlerts()
    if (this.isValid()) {
      await this.props.onSubmit(form)
    }
  }
}

export default MostActiveCPT4Form
